import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { canAccessRoute } from '@/utils/permissions'
import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: (to: any) => {
        const authStore = useAuthStore()
        const chatsRoute = routes.find((route) => route.path === '/chatters')

        // Check if user has access to chats
        if (chatsRoute && canAccessRoute(authStore.user, chatsRoute.meta)) {
          return '/chatters'
        } else {
          return '/webinars'
        }
      },
    },
    ...routes,
  ] as any,
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore()

  // Проверяем доступ к маршруту
  if (!canAccessRoute(authStore.user, to.meta)) {
    // Если у пользователя нет нужной роли или он не аутентифицирован
    if (!authStore.isAuthenticated) {
      return '/login'
    }
    return '/webinars'
  }

  return true
})

export default router
